import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'

import image1 from '../resources/p8_img1.svg'
import image2 from '../resources/p8_img2.svg'
import image3 from '../resources/p8_img3.svg'
import image4 from '../resources/p8_img4.svg'
import image5 from '../resources/p8_img5.svg'
import button1 from '../resources/p8_img6.svg'
import button2 from '../resources/p8_img7.svg'
import price_table from '../resources/p8_img6.png'


class Section8 extends Component {
  render() {
    return (
      <section id="page_8">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 text-center">
              <div className="row">
                <div className="col-sm-offset-3 col-sm-6 col-xs-8">
                  <div className="academy_plan text-center">
                    <span>ACADEMY PLAN</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div id="premium">
                  <div className="col-sm-offset-3 col-sm-3 col-xs-4">
                    <div className="col-xs-12 price_type">
                      PREMIUM
                    </div>
                    <div className="col-xs-12 price_info">
                      <div className="month_price"> 5,280 円/月 （税込）</div>
                      <div className="year_price"> 52,800円/年（税込） </div>
                      <a href="https://academy-admin.themusio.com/signup">
                        <img src={button1} className="img-responsive price_button" />
                      </a>
                    </div>
                  </div>
                </div>
                <div id="basic">
                  <div className="col-sm-3 col-xs-4">
                    <div className="col-xs-12 price_type">
                      BASIC
                    </div>
                    <div className="col-xs-12 price_info">
                      <div className="month_price"> 1,078 円/月 （税込）</div>
                      <div className="year_price"> 10,780円/年 （税込）</div>
                      <a href="https://academy-admin.themusio.com/signup">
                        <img src={button1} className="img-responsive price_button" />
                      </a>
                    </div>
                  </div>
                </div>
                <div id="friend_plan">
                  <div className="col-sm-3 col-xs-4">
                    <div className="col-xs-12 price_type">
                      FRIEND PLAN
                    </div>
                    <div className="col-xs-12 price_info">
                      <div className="month_price"> 1,080 円/月<br/>（税込） </div>
                      <br/>
                      <a href="https://store.themusio.com/service/fp">
                        <img src={button2} className="img-responsive price_button" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="visible-xs row">
                <div className="col-xs-12">
                  <div className="text-center columns">
                    生徒数
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="hidden-xs col-xs-3">
                  <div className="text-right columns">
                    生徒数
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns premium_column1">
                    50人
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns basic_column1">
                    5人
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns friend_column1">
                    (1人)
                  </div>
                </div>
              </div>
              <div className="visible-xs row">
                <div className="col-xs-12">
                  <div className="text-center columns">
                    複数プラン加入
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="hidden-xs col-xs-3">
                  <div className="text-right columns">
                    複数プラン加入
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns premium_column2">
                    O
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns basic_column2">
                    X
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns friend_column2">
                    X
                  </div>
                </div>
              </div>

              <div className="visible-xs row">
                <div className="col-xs-12">
                  <div className="text-center columns">
                    Academy Mode
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="hidden-xs col-xs-3">
                  <div className="text-right columns">
                    Academy Mode
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns premium_column1">
                    O
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns basic_column1">
                    O
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns friend_column1">
                    X
                  </div>
                </div>
              </div>

              <div className="visible-xs row">
                <div className="col-xs-12">
                  <div className="text-center columns">
                    コンテンツ編集機能
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="hidden-xs col-xs-3">
                  <div className="text-right columns">
                    コンテンツ編集機能
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns premium_column2">
                    O
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns basic_column2">
                    O
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns friend_column2">
                    X
                  </div>
                </div>
              </div>

              <div className="visible-xs row">
                <div className="col-xs-12">
                  <div className="text-center columns">
                    生徒学習管理機能
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="hidden-xs col-xs-3">
                  <div className="text-right columns">
                    生徒学習管理機能
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns premium_column1">
                    O
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns basic_column1">
                    O
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns friend_column1">
                    X
                  </div>
                </div>
              </div>

              <div className="visible-xs row">
                <div className="col-xs-12">
                  <div className="text-center columns">
                    A I チャット
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="hidden-xs col-xs-3">
                  <div className="text-right columns">
                    A I チャット
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns premium_column2">
                    O
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns basic_column2">
                    O
                  </div>
                </div>
                <div className="col-sm-3 col-xs-4">
                  <div className="col-xs-12 text-center columns friend_column2">
                    O
                  </div>
                </div>
              </div>


              <div className="notice">
                ※コースをご利用の際は、Musioのご購入が必要です。
              </div>
            </div>
            <div className="col-sm-offset-4 col-sm-4 col-xs-12 text-center">
            <a href="https://store.themusio.com/">
              <div className="button">
                Musioのご購入はこちら
              </div>
            </a>
            </div>
          </div>
          <div className="row">
            <div className="buy_progress">
              <div className="col-xs-12 text-center">
                <div className="content_wrapper col-md-2 col-sm-4 col-xs-6">
                  <div className="p8_buy">
                    <img src={image1} alt="image1"/>
                    <div className="arrow">
                      >
                    </div>
                    <div className="content">
                      1. ユーザーIDを登録
                    </div>
                  </div>
                </div>
                <div className="content_wrapper col-md-2 col-sm-4 col-xs-6">
                  <div className="p8_buy">
                    <img src={image2} alt="image2"/>
                    <div className="arrow">
                      >
                    </div>
                    <div className="content">
                      2. 申請情報を記入
                    </div>
                  </div>
                </div>
                <div className="content_wrapper col-md-2 col-sm-4 col-xs-6">
                  <div className="p8_buy">
                    <img src={image3} alt="image3" />
                    <div className="arrow">
                      >
                    </div>
                    <div className="content">
                      3. コースを選択
                    </div>
                  </div>
                </div>
                <div className="content_wrapper col-md-offset-0 col-md-2 col-sm-offset-2 col-sm-4 col-xs-6">
                  <div className="p8_buy">
                    <img src={image4} alt="image4"/>
                    <div className="arrow">
                      >
                    </div>
                    <div className="content">
                      4. お支払い方法を選択
                    </div>
                  </div>
                </div>
                <div className="content_wrapper col-md-2 col-sm-offset-0 col-sm-4 col-xs-offset-3 col-xs-6">
                  <div className="p8_buy">
                    <img src={image5} alt="image5"/>
                    <div className="content">
                      5. 完了!
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Section8;



// WEBPACK FOOTER //
// ./src/sections/Section8.js